"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createYouTubeContentStyle;

function createYouTubeContentStyle(_ref) {
  var videoHeight = _ref.videoHeight;
  return {
    border: 0,
    height: videoHeight,
    width: '100%'
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9TdHlsZXMvU3R5bGVTZXQvWW91VHViZUNvbnRlbnQudHMiXSwibmFtZXMiOlsiY3JlYXRlWW91VHViZUNvbnRlbnRTdHlsZSIsInZpZGVvSGVpZ2h0IiwiYm9yZGVyIiwiaGVpZ2h0Iiwid2lkdGgiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFFZSxTQUFTQSx5QkFBVCxPQUF3RTtBQUFBLE1BQW5DQyxXQUFtQyxRQUFuQ0EsV0FBbUM7QUFDckYsU0FBTztBQUNMQyxJQUFBQSxNQUFNLEVBQUUsQ0FESDtBQUVMQyxJQUFBQSxNQUFNLEVBQUVGLFdBRkg7QUFHTEcsSUFBQUEsS0FBSyxFQUFFO0FBSEYsR0FBUDtBQUtEIiwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBTdHJpY3RTdHlsZU9wdGlvbnMgfSBmcm9tICdib3RmcmFtZXdvcmstd2ViY2hhdC1hcGknO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBjcmVhdGVZb3VUdWJlQ29udGVudFN0eWxlKHsgdmlkZW9IZWlnaHQgfTogU3RyaWN0U3R5bGVPcHRpb25zKSB7XG4gIHJldHVybiB7XG4gICAgYm9yZGVyOiAwLFxuICAgIGhlaWdodDogdmlkZW9IZWlnaHQsXG4gICAgd2lkdGg6ICcxMDAlJ1xuICB9O1xufVxuIl19